/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'hs-insights';
const prefix = `${moduleName}.${componentName}`;

export const topFactorsAffectingHealthScoreMessage = `${prefix}.topFactorsAffectingHealthScoreMessage`;

export const ENGLISH = {
    [topFactorsAffectingHealthScoreMessage]: 'Top Factors Affecting Health Score',
};
